// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2aYdv","buttons":"SendReceipts_buttons__1ap2q","email":"SendReceipts_email__3iFVV","bookApptTitle":"SendReceipts_bookApptTitle__23hWO"};